import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { AppointmentsPage } from '@/features/appointments/appointments-page'

const appointmentStatusValues = [
  'scheduled',
  'pending_authorization',
  'completed',
  'cancelled_by_patient',
  'cancelled_by_doctor',
  'cancelled_by_provider',
  'no_show',
  'doctor_no_show',
] as const

const appointmentsSearchSchema = z.object({
  status: z.enum(appointmentStatusValues).optional().catch(undefined),
  fromDate: z.string().optional().catch(undefined),
  toDate: z.string().optional().catch(undefined),
  page: z.number().int().positive().optional().catch(1),
  perPage: z.number().int().positive().optional().catch(undefined),
  pageSize: z.number().int().positive().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/appointments/')({
  validateSearch: appointmentsSearchSchema,
  component: AppointmentsPage,
})
